export default __webpack_public_path__ + "static/media/earth_stencils.2fb8f29f.jpg";